<adapt-dialog [maxWidth]="700">
    <h3 adapt-dialog-title>Merging Labels</h3>
    <div adapt-dialog-content
         class="d-flex flex-column">
        <div class="row center-content">
            <div class="col-5 d-flex flex-column">
                <h3>Merge:</h3>
                @for (label of sourceLabels; track label) {
                    <adapt-display-label class="mt-2"
                                         [label]="label"
                                         [adaptLinkDisabled]="true"></adapt-display-label>
                }
            </div>
            <div class="col-2 text-center mt-2">
                <h3>INTO <i class="fal fa-fw fa-long-arrow-right"></i></h3>
            </div>
            <div class="col-5">
                <dx-select-box [dataSource]="sourceLabels"
                               [searchEnabled]="false"
                               fieldTemplate="field"
                               (valueChange)="onSelectedLabelChanged($event)"
                               data-test="label-merge-select">
                    <div *dxTemplate="let item of 'item'">
                        <adapt-display-label [label]="item"
                                             [adaptLinkDisabled]="true"></adapt-display-label>
                    </div>
                    <div *dxTemplate="let item of 'field'">
                        @if (item) {
                            <div class="m-2">
                                <dx-text-box class="d-none"></dx-text-box>
                                <!-- Required for field template -->
                                <adapt-display-label [label]="item"
                                                     [adaptLinkDisabled]="true"></adapt-display-label>
                            </div>
                        } @else {
                            <dx-text-box [readOnly]="true"
                                         [disabled]="true"
                                         value="Select a destination label..."></dx-text-box>
                        }
                    </div>
                </dx-select-box>
            </div>
        </div>
        @if (!!selectedDestination) {
            @if (sourceItemCount + sourceTeamCount + sourceObjectiveCount + sourceSystemCount + sourceProcessStepCount + sourceRoleCount > 0) {
                <div class="mt-3">
                    The impact of merging labels into
                    <adapt-display-label [label]="selectedDestination"
                                         [adaptLinkDisabled]="true"></adapt-display-label>
                    will result in:
                    <ul class="mt-2">
                        <li>
                            The {{ sourceLabels.length - 1 }} source
                            {{ sourceLabels.length > 2 ? "labels" : "label" }}
                            to be deleted and removed from the following:
                            <ul>
                                @if (sourceItemCount > 0) {
                                    <li>{{ sourceItemCount }} items</li>
                                }
                                @if (sourceTeamCount > 0) {
                                    <li>{{ sourceTeamCount }} teams</li>
                                }
                                @if (sourceObjectiveCount > 0) {
                                    <li>{{ sourceObjectiveCount }} objectives</li>
                                }
                                @if (sourceSystemCount > 0) {
                                    <li>{{ sourceSystemCount }} systems</li>
                                }
                                @if (sourceProcessStepCount > 0) {
                                    <li>{{ sourceProcessStepCount }} process steps</li>
                                }
                                @if (sourceRoleCount > 0) {
                                    <li>{{ sourceRoleCount }} roles</li>
                                }
                            </ul>
                        </li>
                        <li>
                            The merged label
                            <adapt-display-label [label]="selectedDestination"
                                                 [adaptLinkDisabled]="true"></adapt-display-label>
                            to be added to the above.
                        </li>
                    </ul>
                </div>
            }
            <dx-check-box class="mt-3"
                          [(value)]="confirmMerge"
                          text="Check to confirm that you understand that this action cannot be undone"
                          data-test="confirm-checkbox"></dx-check-box>
        }
    </div>
    <adapt-standard-dialog-buttons adapt-dialog-footer
                                   [saveIsDisabled]="!selectedDestination || !confirmMerge"
                                   [saveBlockingClick]="saveAndClose"
                                   [discardConfirmationInstance]="instance"> </adapt-standard-dialog-buttons>
</adapt-dialog>
